'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _lib = require('helpers/lib');

require('firebase/auth');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';
var Account = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}, (0, _extends3.default)({}, authActions, { pushState: _reactRouterRedux.push })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Account, _Component);

  function Account() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Account);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Account.__proto__ || (0, _getPrototypeOf2.default)(Account)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentNav: 'accountInfo'
    }, _this.handleChangeNav = function (nav) {
      _this.setState({ currentNav: nav });
    }, _this.handleLogout = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                _this.props.logout();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Account, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.user && !nextProps.user) {
        // logout
        this.props.pushState('/');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./Account.scss');
      var currentNav = this.state.currentNav;
      var user = this.props.user;

      var avt = (0, _lib.getAvatar)(user);
      return _react2.default.createElement(
        'div',
        { className: 'container ' + styles.account },
        _react2.default.createElement(
          _reactBootstrap.Row,
          { style: { margin: 0 } },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 3, className: styles.accountSidebar },
            _react2.default.createElement(
              'div',
              { className: styles.avtName },
              _react2.default.createElement('img', { src: avt }),
              _react2.default.createElement(
                'div',
                { className: styles.name },
                user && user.profile && user.profile.name
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.sidebarNav + (currentNav === 'accountInfo' ? ' ' + styles.active : ''),
                onClick: function onClick() {
                  return _this3.handleChangeNav('accountInfo');
                }
              },
              'Th\xF4ng tin t\xE0i kho\u1EA3n'
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.sidebarNav + (currentNav === 'activities' ? ' ' + styles.active : ''),
                onClick: function onClick() {
                  return _this3.handleChangeNav('activities');
                }
              },
              'Ho\u1EA1t \u0111\u1ED9ng'
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.sidebarNav + (currentNav === 'voucher' ? ' ' + styles.active : ''),
                onClick: function onClick() {
                  return _this3.handleChangeNav('voucher');
                }
              },
              '\u0110i\u1EC3m th\u01B0\u1EDFng & Voucher'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.sidebarNav, onClick: this.handleLogout },
              '\u0110\u0103ng xu\u1EA5t'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 9, className: styles.accountRight },
            currentNav === 'accountInfo' && _react2.default.createElement(_components.AccountInfo, null),
            currentNav === 'activities' && _react2.default.createElement(_components.Activities, null),
            currentNav === 'collections' && _react2.default.createElement(_components.MyCollections, null),
            currentNav === 'voucher' && _react2.default.createElement(_components.Voucher, null)
          )
        )
      );
    }
  }]);
  return Account;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  logout: _react.PropTypes.func.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = Account;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Account/Account.js
// module id = 1659
// module chunks = 0